/** Get the default gradients we use */

import type { Theme } from '@mui/material'
import type { ColorStop } from './wave-canvas-draw.js'

interface GetWaveGradient {
  type?: 'audio' | 'monitor'
  theme: Theme
}

export const getWaveGradient = ({ theme, type = 'audio' }: GetWaveGradient): ColorStop[] => {
  if (type === 'audio') {
    /** @note we cannot use theme.vars here because we do calculations with these values */
    return [
      [0, theme.palette.primary.dark],
      [0.5, theme.palette.primary.light],
      [1, theme.palette.primary.dark],
    ]
  }
  if (type === 'monitor') {
    return [
      [0, theme.palette.warning.dark],
      [0.5, theme.palette.text.primary],
      [1, theme.palette.warning.dark],
    ]
  }
  throw new Error(`Unknown wave type: ${type}`)
}
